module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-container work-container",
    class: _vm.viewMode
  }, [_c('article', {
    staticClass: "work detail-content"
  }, [_c('div', {
    staticClass: "fixed-container"
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('div', {
    staticClass: "icon-cancel",
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        _vm.hideFull()
      }
    }
  })])]), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    staticClass: "edit-bar"
  }, [_c('div', {
    staticClass: "edit",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.editNode(_vm.fullNode.nid)
      }
    }
  }, [_vm._v("Edit")])]) : _vm._e(), _vm._v(" "), (_vm.fullNode.hasImages) ? _c('div', {
    staticClass: "pictures",
    class: _vm.fullNode.imageClasses
  }, _vm._l((_vm.fullNode.images), function(img, index) {
    return (img.show) ? _c('figure', [(img.picture) ? [_c('vue-picture', {
      attrs: {
        "imgset": img,
        "sizes": _vm.fullSizes,
        "className": img.attributes.className
      }
    })] : [_c('picture', {
      staticClass: "original",
      class: img.attributes.className
    }, [_c('img', {
      attrs: {
        "src": img.sizes.orig,
        "alt": img.attributes.title,
        "width": img.attributes.width,
        "height": img.attributes.height
      }
    })])], _vm._v(" "), _c('figcaption', [_vm._v(_vm._s(img.attributes.alt))])], 2) : _vm._e()
  })) : _vm._e(), _vm._v(" "), _c('h2', {
    staticClass: "article-title"
  }, [_vm._v(_vm._s(_vm.fullNode.title))]), _vm._v(" "), _c('div', {
    staticClass: "info"
  }, [_c('time', {
    staticClass: "date"
  }, [_vm._v(_vm._s(_vm.fullNode.date))]), _vm._v(" "), _c('h5', {
    staticClass: "category"
  }, [_vm._v(_vm._s(_vm.fullNode.category))])]), _vm._v(" "), _c('div', {
    staticClass: "body",
    domProps: {
      "innerHTML": _vm._s(_vm.fullNode.body)
    }
  }), _vm._v(" "), _vm._l((_vm.fullNode.sections), function(section, index) {
    return [_c('div', {
      staticClass: "section",
      class: 'section-' + index
    }, [(section.has_media) ? [_c('div', {
      staticClass: "media",
      class: section.media.type
    }, [(section.media.type == 'embed') ? [_c('vue-embedplayer', {
      attrs: {
        "media": section.media,
        "current": _vm.mediaPlaying
      }
    })] : _vm._e(), _vm._v(" "), (section.media.type == 'video') ? [_c('vue-videoplayer', {
      attrs: {
        "media": section.media,
        "current": _vm.mediaPlaying
      }
    })] : _vm._e(), _vm._v(" "), (section.media.type == 'audio') ? [_c('vue-audioplayer', {
      attrs: {
        "media": section.media,
        "current": _vm.mediaPlaying
      }
    })] : _vm._e()], 2)] : _vm._e(), _vm._v(" "), (section.hasImages) ? [_c('div', {
      staticClass: "pictures",
      class: section.imageClasses
    }, [_vm._l((section.images), function(img, imgIndex) {
      return [_c('figure', {
        key: imgIndex
      }, [(img.picture) ? [_c('vue-picture', {
        attrs: {
          "imgset": img,
          "sizes": _vm.fullSizes,
          "className": img.attributes.className
        }
      })] : [_c('picture', {
        staticClass: "original",
        class: img.attributes.className
      }, [_c('img', {
        attrs: {
          "src": img.sizes.orig,
          "alt": img.attributes.title,
          "width": img.attributes.width,
          "height": img.attributes.height
        }
      })])], _vm._v(" "), _c('figcaption', [_vm._v(_vm._s(img.attributes.alt))])], 2)]
    })], 2)] : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "text",
      domProps: {
        "innerHTML": _vm._s(section.text)
      }
    })], 2)]
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "work main-content",
    class: {
      'images-loaded': _vm.imgsLoaded
    },
    attrs: {
      "data-scroll": _vm.prevY
    }
  }, [_c('h2', {
    staticClass: "content-title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
    staticClass: "edit-bar"
  }, [_c('div', {
    staticClass: "edit",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.addNode()
      }
    }
  }, [_vm._v("Add new")])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "slides"
  }, [(_vm.numSlides > 0) ? _c('isotope', {
    directives: [{
      name: "images-loaded",
      rawName: "v-images-loaded:on.progress",
      value: (_vm.layout),
      expression: "layout",
      arg: "on",
      modifiers: {
        "progress": true
      }
    }],
    ref: "cpt",
    attrs: {
      "options": _vm.getOptions(),
      "list": _vm.slides
    },
    on: {
      "sort": function($event) {
        _vm.sortOption = arguments[0]
      }
    }
  }, _vm._l((_vm.slides), function(slide, si) {
    return _c('li', {
      key: si,
      class: slide.classNames,
      attrs: {
        "data-index": si,
        "data-id": slide.nid,
        "data-path": slide.path
      }
    }, [_c('v-touch', {
      staticClass: "tap-overlay",
      attrs: {
        "tag": "div",
        "data-index": si
      },
      on: {
        "tap": _vm.hideShowCaption
      }
    }), _vm._v(" "), _c('figure', {
      directives: [{
        name: "scroll-to",
        rawName: "v-scroll-to",
        value: ('body'),
        expression: "'body'"
      }],
      staticClass: "pictures",
      class: 'num-images-' + slide.numImages,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.showFullNode(slide)
        }
      }
    }, [_vm._l((slide.images), function(img, index) {
      return [(img.listed) ? [(img.picture) ? [_c('vue-picture', {
        attrs: {
          "imgset": img,
          "sizes": _vm.pictureSizes,
          "className": 'active'
        }
      })] : [_c('picture', {
        staticClass: "original active"
      }, [_c('img', {
        attrs: {
          "src": img.sizes.orig,
          "alt": img.attributes.title,
          "width": img.attributes.width,
          "height": img.attributes.height
        }
      })])]] : _vm._e(), _vm._v(" "), _c('figcaption', [_c('div', {
        staticClass: "inner"
      }, [_c('h4', [_vm._v(_vm._s(slide.title))]), _vm._v(" "), _c('hr', {
        staticClass: "divider"
      }), _vm._v(" "), _c('p', {
        staticClass: "category"
      }, [_vm._v(_vm._s(slide.category))])])])]
    })], 2), _vm._v(" "), (_vm.isAdmin) ? _c('div', {
      staticClass: "sort-bar"
    }, [_c('div', {
      staticClass: "arrow up",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.sortSlides(si, 'up')
        }
      }
    }, [_vm._v("↑")]), _c('div', {
      staticClass: "weight"
    }, [_vm._v(_vm._s((si + 1)))]), _c('div', {
      staticClass: "arrow down",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.sortSlides(si, 'down')
        }
      }
    }, [_vm._v("↓")])]) : _vm._e()], 1)
  })) : _vm._e()], 1)]), _vm._v(" "), (_vm.isAdmin && _vm.viewMode == 'show-listing') ? _c('div', {
    staticClass: "sort-save"
  }, [(_vm.sortMessage.length > 3) ? _c('p', {
    staticClass: "message"
  }, [_vm._v(_vm._s(_vm.sortMessage))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "shuffle",
    attrs: {
      "title": _vm.shuffleHint
    },
    on: {
      "click": function($event) {
        _vm.toggleShuffle()
      }
    }
  }, [_vm._v("Shuffle " + _vm._s(_vm.shuffleMode))]), _vm._v(" "), _c('div', {
    staticClass: "button",
    on: {
      "click": function($event) {
        _vm.saveSort()
      }
    }
  }, [_vm._v("Save sort")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-283f8326"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Work.vue
// module id = 337
// module chunks = 1